<template>
  <v-dialog
    v-model="internalDialogVisible"
    max-width="570px"
    :persistent="false"
    content-class="panda-assist-dialog"
    @input="handleDialogClose"
  >
    <v-card flat>
      <v-row no-gutters class="pa-6">
        <v-col cols="8">
          <span class="body-bold-medium neutral-20-dark--text">
            Alterar Tutor
          </span>
          <p class="body-regular-smaller neutral-40-light--text">
            Escolha onde o conteúdo desse video irá aparecer
          </p>
        </v-col>
        <v-col class="d-flex justify-end" style="align-items: flex-start">
          <v-icon
            @click="closeModal"
            class="close-icon"
            size="24"
            color="#666D99"
            style="cursor: pointer"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
      <v-card-text class="text-center" style="padding: 0; width: 100%">
        <div
          v-if="step === 1"
          style="border-radius: 12px; padding: 10px; padding-top: 0"
        >
          <div>
            <v-radio-group
              v-model="isDefaultText"
              hide-details
              dense
              class="mt-0 pt-0 ml-2"
            >
              <div v-for="(item, index) in pandaAssists" :key="item.id">
                <v-radio :label="item.name" :value="item.id">
                  <template #label>
                    <span class="body-regular-small neutral-20-dark--text">
                      {{ item.name }}
                    </span>
                  </template>
                </v-radio>
                <v-divider
                  v-if="index + 1 !== pandaAssists.length"
                  class="mb-3"
                ></v-divider>
              </div>
            </v-radio-group>
          </div>
        </div>
      </v-card-text>

      <v-divider class="mt-4"></v-divider>
      <v-card-actions class="pa-6 pl-3">
        <base-btn
          type="neutral"
          class="brand-20--text"
          @click="openCreatePandaAssist = true"
        >
          <span class="brand-20--text">Criar Tutor</span>
        </base-btn>
        <v-spacer></v-spacer>
        <base-btn type="tertiary" @click="closeModal">
          <span>{{ $t('message.pages.externalSourceVideo.cancel') }}</span>
        </base-btn>
        <base-btn type="primary" class="ml-3">
          <span>{{ $t('message.pages.externalSourceVideo.confirm') }}</span>
        </base-btn>
      </v-card-actions>
      <CreatePandaAssist
        :dialog-visible="openCreatePandaAssist"
        @update:dialog-visible="openCreatePandaAssist = $event"
      ></CreatePandaAssist>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseBtn from '../../../../components/BaseBtn.vue'
import pandaAssist from '@/services/pandaAssist'
import CreatePandaAssist from '../../../PandaAssist/CreatePandaAssist.vue'
export default {
  components: { BaseBtn, CreatePandaAssist },
  name: 'ChangePandaAssist',
  props: {
    dialogChangeVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      internalDialogVisible: this.dialogChangeVisible,
      step: 1,
      totalSteps: 5,
      name: '',
      isDefaultText: '',
      initialQuestion: '',
      suggestionEnabled: false,
      openCreatePandaAssist: false,
      selectPandaAssist: {},
      videos: [
        { id: 1, name: 'Vídeo 1' },
        { id: 2, name: 'Vídeo 2' },
        { id: 3, name: 'Vídeo 3' },
      ],
      pandaAssists: [
        { id: 1, name: 'Adestramento chat com IA da Panda Video' },
        { id: 2, name: 'Adestramento avançado' },
      ],
      selectedVideos: [],
    }
  },
  watch: {
    dialogChangeVisible(newVal) {
      this.internalDialogVisible = newVal
    },
    internalDialogVisible(newVal) {
      this.$emit('update:dialog-change-visible', newVal)
    },
  },
  methods: {
    selectOption() {
      this.$emit('option-selected', this.selectPandaAssist)
      this.closeModal()
    },
    async getPandaAssists() {
      const response = await pandaAssist.getAssistants()
      this.pandaAssists = response.data.filter(
        (item) => item.status !== 'deleted'
      )
      this.noCredits = this.pandaAssists.some(
        (item) => item.status === 'payment_failed'
      )
      const videoIds = this.pandaAssists
        .flatMap((item) => item.videos)
        .map((video) => video)

      this.pandaAssistVideos = videoIds
      this.fetching = false
    },
    closeModal() {
      if (this.internalDialogVisible) {
        this.internalDialogVisible = false
        this.resetModal()
      }
    },
    handleDialogClose(isVisible) {
      if (typeof isVisible === 'boolean') {
        this.internalDialogVisible = isVisible
        if (!isVisible) {
          this.resetModal()
        }
      } else {
        console.warn('Valor inesperado no handleDialogClose:', isVisible)
      }
    },
    resetModal() {
      try {
        this.step = 1
        this.selectPandaAssist = {}
        this.selectedVideos = []
        this.name = ''
        this.initialQuestion = ''
        console.log('Modal resetado com sucesso.')
      } catch (error) {
        console.error('Erro ao resetar o modal:', error)
      }
    },
  },
  mounted() {
    // this.getPandaAssists()
  },
}
</script>

<style scoped lang="scss">
.selected-video {
  background-color: #e0f7fa !important;
}
.assistHeadline {
  white-space: normal;
  word-break: break-word;
}
.step-indicators {
  display: flex;
  gap: 8px;
}
.step-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: varFigma(neutral-80-lighter);
  transition: background 0.3s ease;
}
.brand-20--text {
  color: varFigma(brand) !important;
}
.step-indicator.active {
  background: varFigma(brand-60-base);
}
.questionSugestion {
  color: #636578;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.66px;
  text-transform: uppercase;
}
::v-deep .panda-assist-dialog {
  background: varFigma(neutral-100-white) !important;
}
</style>
